import { TFunction } from 'i18next';
import { WHITESPACE_REGEX, MERCHANT_NAME_REGEX, MAX_GLOBAL_AGGREGATE_THRESHOLD } from 'Utils';

import * as Yup from 'yup';

export const IdSchema = (t: TFunction) => {
    return Yup.string()
        .required(t('required', { field: 'Merchant ID' }))
        .matches(WHITESPACE_REGEX, t('No whitespace allowed'))
        .matches(MERCHANT_NAME_REGEX, t('alphanumeric', { field: 'Merchant ID' }))
        .max(40, t('maxLength', { field: 'Merchant ID', charCount: 40 }));
};

export const ThresholdSchema = (
    showMerchantThreshold: boolean,
    t: TFunction,
    maxGlobalAggregateThreshold: number = MAX_GLOBAL_AGGREGATE_THRESHOLD
) => {
    return showMerchantThreshold
        ? Yup.number()
              .required(t('integer', { field: 'Threshold' }))
              .positive(t('integer', { field: 'Threshold' }))
              .integer(t('integer', { field: 'Threshold' }))
              .max(maxGlobalAggregateThreshold)
        : Yup.string().nullable();
};
